var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CardModal } from "../CardList/Card";
import styles from "../../styles/GuessCell.module.scss";
var GuessCell = function (_a) {
    var _b;
    var guessCard = _a.guessCard;
    var cardUrl = (guessCard.card_faces && guessCard.card_faces[0].image_uris)
        ? guessCard.card_faces[0].image_uris.art_crop
        : (_b = guessCard.image_uris) === null || _b === void 0 ? void 0 : _b.art_crop;
    var trigger = (_jsx("button", __assign({ className: styles.guessCell }, { children: _jsx("img", { alt: guessCard.name, src: cardUrl, className: styles.image }, void 0) }), void 0));
    return _jsx(CardModal, { card: guessCard, trigger: trigger }, void 0);
};
export default GuessCell;
